export const rexEmaillpha = /^([a-zA-Z]+)$/;
export const rexAlphaPunc = /^([a-zA-Z -]+)$/;
export const rexAlphaPuncExt = /^([a-zA-Z .,;:_-]+)$/;
export const rexAlphaNum = /^([a-zA-Z0-9]+)$/;
export const rexAlphaNumExt = /^([a-zA-Z0-9 -]+)$/;
export const rexAlphaNumPunc = /^([a-zA-Z0-9 .,;:_-]+)$/;
export const rexAlphaNumPuncExt = /^([\n\p{L}0-9 .,;:_-]+)$/iu;
export const rexNum = /^([0-9]+)$/;
// export const rexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// The following regex is recommended by platform
export const rexEmail = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;


// Vest schemas - can be imported into relevant suites, docs:
// https://vestjs.dev/docs/enforce/composing_enforce_rules
// import compose from 'vest/enforce/compose';
import { enforce } from 'vest';

export function isEmail(form: { email: string }) {
  return enforce(form.email)
    .message('Please provide your email')
    .isNotEmpty();
    // .message('Please provide a valid email address')
    // .matches(rexEmail);
}
